import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Componente wrapper que verifica se o User Agent deve ser bloqueado
 * Se bloqueado, redireciona para a URL configurada
 */
const UserAgentGuard = ({ children }) => {
  const [checking, setChecking] = useState(true);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    const checkUserAgent = async () => {
      try {
        const response = await axios.post(`${API}/check-user-agent`, {});
        
        if (response.data.blocked) {
          setBlocked(true);
          // Redirect after a small delay
          setTimeout(() => {
            window.location.href = response.data.redirect_url || 'https://google.com';
          }, 100);
        } else {
          setChecking(false);
        }
      } catch (error) {
        // If check fails, allow access
        console.error('User agent check failed:', error);
        setChecking(false);
      }
    };

    checkUserAgent();
  }, []);

  // Show nothing while checking or if blocked
  if (checking || blocked) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-gray-200 border-t-[#14453D] rounded-full animate-spin"></div>
      </div>
    );
  }

  return children;
};

export default UserAgentGuard;
